import { GenericDateFilterFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const AuditLogsDateFilterStore = GenericDateFilterFactory(GENERIC_IDS.AUDIT);